import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import appConfig from '../../config/config';
import DropdownList from 'react-widgets/lib/DropdownList';
import {renderDatePicker} from "../common/renderinput"
import {
    Card, CardBody,
    CardTitle, Form, Row, FormGroup, Button, Col, Input
} from 'reactstrap';
import { connect } from 'react-redux';
import axios from 'axios';
import moment from 'moment';
var statusData=[
    {valueField:'OC', textField : 'Open'},
    {valueField:'OCD', textField : 'Completed'}
    
]
class SearchOrderForm extends Component {
    constructor(props) {
        super(props);
    }

    handleSearch = (values) => {
        //Use axios to send request
        //var valwithDate = values.map((v)=>{ console.log(v) })
        var searchDate = ''
        for (var i in values)
        {
            if ( i == 'OrderDate')
            searchDate = moment(new Date(values[i])).format('MM/DD/YYYY')
        }
        this.props.loading(true);
        axios.post(
            appConfig.apiGateway.searchUrl,
            JSON.stringify({...values,User:this.props.session.session.user.email, 
                    OrderDate : searchDate,
                    Role:this.props.session.session.user.role[0], 
                    Action:"OrderSearch"}),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${this.props.session.session.credentials.accessToken}`
                }
            }
        ).then(response => {
            this.props.loading(false);
            this.props.complete(JSON.parse(response.data.body));
        }, error => {
            this.props.loading(false);
        });

        //Set loading to parent
        //if success loading false, set data
        //if error loading false display banner
    }

    renderInput({ input, placeholder }) {
        return (
            <input {...input} className="form-control" placeholder={placeholder} />
            );
    }
    renderDropdown({input, data, valueField, textField, placeholder}) {
        return (
            <DropdownList {...input}
                onBlur={() => input.onBlur()}
                value={input.value || []} // requires value to be an array
                data={data}
                valueField={valueField}
                textField={textField}
            />
        )
    }
    render() {
        return (
            <>
                <Card className="w-100">
                    <CardBody>
                        <CardTitle>Search Criteria</CardTitle>
                        <form onSubmit={this.props.handleSubmit(this.handleSearch)}>
                            <Row form>
                                <Col md={2}>
                                    <FormGroup>
                                        <Field name="OrderId" component={this.renderInput} placeholder="Order" />
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Field name="LoanId" component={this.renderInput} placeholder="Loan no" />
                                    </FormGroup>
                                </Col>
                                <Col md={2}>
                                    <FormGroup>
                                        <Field name="Address" component={this.renderInput} placeholder="Property Address" />
                                    </FormGroup>
                                </Col>
                                <Col md={2}>
                                    <FormGroup>
                                        <Field name="User" component={this.renderInput} placeholder="User" />
                                    </FormGroup>
                                </Col>

                                <Col md={2}>
                                    <FormGroup>
                                        <Button color="primary" >Search</Button>
                                        <Button className="ml-3" >Reset</Button>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row form>
                            <Col md={2}>
                            <FormGroup>
                                <Field
                                    name="OrderDate"
                                    showTime={false}
                                    component={renderDatePicker}
                                    />
                            </FormGroup>
                            </Col>
                            <Col md={3}>
                                    <FormGroup>
                                        <Field name="LosId" 
                                        component={this.renderInput} placeholder="LOS ID" />  
                                    </FormGroup>
                                </Col>
                            </Row>
                        </form>
                    </CardBody>
                </Card>
            </>
        );
    }
}

const validate = (formvalues) => {

}

const mapStatetoProps = state => {
    return { session: state.session }
}



var sf = reduxForm({
    form: 'searchOrderform',
    validate
})(SearchOrderForm);

sf = connect(mapStatetoProps)(sf);

export default sf;